enum DemandesTechniqueEnum {
	entree = 1,
	serruresbarillets,
	clesbadges,
	electriciteeclairage,
	detecteurfumee,
	fenetresencadrements,
	voletsbasse,
	voletshaute,
	vitrage,
	convecteursradiateurs,
	mursinterieurs,
	parquets,
	moquetterevetements,
	aerationventilation,
	vmc,
	arriveegaz,
	flexiblegaz,
	flexiblegrillesiphon,
	colonneeaux,
	canalisationseauusees,
	abattantswc,
	canalisationeau,
	douchetteflexibledouche,
	carrelagefaience,
	robinetterie,
	chasseeau,
	evierslavabosbaignoiressanitaires,
	chaudieremuraleballonelectrique,
	cave,
	boxstationnement,
	terrassebalcon,
	divers,
	electromenager,
	equipementsconfort,
}

export const personneACharge = {
	locatif: {
		serruresbarillets: "serruresbarillets",
		clesbadges: "clesbadges",
		electriciteeclairage: "electriciteeclairage",
		detecteurfumee: "detecteurfumee",
		voletsbasse: "voletsbasse",
		vitrage: "vitrage",
		mursinterieurs: "mursinterieurs",
		parquets: "parquets",
		moquetterevetements: "moquetterevetements",
		aerationventilation: "aerationventilation",
		vmc: "vmc",
		flexiblegrillesiphon: "flexiblegrillesiphon",
		abattantswc: "abattantswc",
		canalisationeau: "canalisationeau",
		douchetteflexibledouche: "douchetteflexibledouche",
		carrelagefaience: "carrelagefaience",
		robinetterie: "robinetterie",
		chasseeau: "chasseeau",
		evierslavabosbaignoiressanitaires: "evierslavabosbaignoiressanitaires",
		cave: "cave",
		boxstationnement: "boxstationnement",
		terrassebalcon: "terrassebalcon",
		divers: "divers",
		electromenager: "electromenager",
		equipementsconfort: "equipementsconfort",
	},
	bailleur: {
		entree: "entree",
		fenetresencadrements: "fenetresencadrements",
		voletshaute: "voletshaute",
		convecteursradiateurs: "convecteursradiateurs",
		arriveegaz: "arriveegaz",
		flexiblegaz: "flexiblegaz",
		colonneeaux: "colonneeaux",
		canalisationseauusees: "canalisationseauusees",
		chaudieremuraleballonelectrique: "chaudieremuraleballonelectrique"

	}
}

export const getInfoForDemandeTechnique = (demandeId: string) => {
	const parentKey = Object.keys(personneACharge)
		.find((subKey: string) => {
			return Object.values(personneACharge[subKey as keyof typeof personneACharge])
				.find(val => val === demandeId)
		}) as keyof typeof personneACharge

	if (parentKey && personneACharge[parentKey]) {
		const chargeCategory = personneACharge[parentKey]
		const valueKey = Object.keys(chargeCategory).find((key: string) => chargeCategory[key as keyof typeof chargeCategory] === demandeId)

		return { parentKey, valueKey }
	}

	return { parentKey: null, valueKey: null }
}

export const getCategorieDemandeTechnique = (value: string) => {
	return Object.getOwnPropertyNames(DemandesTechniqueEnum)[Object.getOwnPropertyNames(DemandesTechniqueEnum).indexOf(value)]
}

export const getValueCategorieDemandeTechnique = (value: string) => {
	return Object.entries(DemandesTechniqueEnum).find(([key, val]) => key === value)?.[1];
}

export default DemandesTechniqueEnum